// react imports
import { useEffect, useState } from "react";
import { useForm, Controller } from "react-hook-form";
import { InputNumber, Table } from "antd";
import { ColumnsType } from "antd/lib/table";
import axios from "axios";

// common imports
import { API_URL } from "common/constants/config";

import CategoryHeader from "./CategoryHeader";
import "./css/Pagination.css";
import "./css/Table.css";
import { PUBLIC_TRANSPORT_TYPE_NAMES } from "./constants/publicTransport";

function PublicTransport() {
  type PublicTransportType = "bus" | "subway" | "railway";
  interface PublicTransportBase {
    averageKmPerRide: number;
    co2GPerPassenger: number;
    co2KgPerPassenger: number;
    co2KgPerRide: number;
  }

  interface PublicTransportInputs {
    [publicTransportType: string]: PublicTransportBase;
  }

  interface PublicTransportData extends PublicTransportBase {
    key: string;
    transportType: string;
  }

  const [publicTransport, setPublicTransport] = useState<PublicTransportData[]>(
    []
  );
  const [fetchAgain, setFetchAgain] = useState<Boolean>(false)
  const { control, handleSubmit } = useForm<PublicTransportInputs>();

  const columns: ColumnsType<PublicTransportData> = [
    {
      title: "Tipo de transporte",
      key: "transportType",
      dataIndex: "transportType",
      align: "center",
      width: 213,
    },
    {
      title: "km/viaje",
      key: "averageKmPerRide",
      dataIndex: "averageKmPerRide",
      align: "center",
      width: 133,
      render: (value, record) => (
        <Controller
          name={`${record.key}.averageKmPerRide`}
          control={control}
          defaultValue={value}
          render={({ field }) => (
            <InputNumber
              {...field}
              decimalSeparator=","
              onPressEnter={handlePressEnter}
            />
          )}
        />
      ),
    },
    {
      title: "g/pasajero",
      key: "co2GPerPassenger",
      dataIndex: "co2GPerPassenger",
      align: "center",
      width: 147,
      render: (value, record) => (
        <Controller
          name={`${record.key}.co2GPerPassenger`}
          control={control}
          defaultValue={value}
          render={({ field }) => (
            <InputNumber
              {...field}
              decimalSeparator=","
              onPressEnter={handlePressEnter}
            />
          )}
        />
      ),
    },
    {
      title: "Kg/pasajero",
      key: "co2KgPerPassenger",
      dataIndex: "co2KgPerPassenger",
      align: "center",
      width: 156,
      render: (value, record) => (
        <Controller
          name={`${record.key}.co2KgPerPassenger`}
          control={control}
          defaultValue={value}
          render={({ field }) => (
            <InputNumber
              //{...field}
              readOnly={true}
              value={record.co2GPerPassenger/1000}
              decimalSeparator=","
              onPressEnter={handlePressEnter}
            />
          )}
        />
      ),
    },
    {
      title: "Kg CO2/viaje",
      key: "co2KgPerRide",
      dataIndex: "co2KgPerRide",
      align: "center",
      width: 133,
      render: (value, record) => (
        <Controller
          name={`${record.key}.co2KgPerRide`}
          control={control}
          defaultValue={value}
          render={({ field }) => (
            <InputNumber
              //{...field}
              value={record.co2GPerPassenger/100}
              decimalSeparator=","
              onPressEnter={handlePressEnter}
              readOnly={true}
            />
          )}
        />
      ),
    },
  ];

  function handlePressEnter(e: React.KeyboardEvent<HTMLInputElement>) {
    e.preventDefault();
  }

  async function onSubmit(values: PublicTransportInputs) {
    setFetchAgain(false)
    const payload = {
      publicTransport: values,
    };

    await axios.put("/admin/calculator/transport", payload, {
      baseURL: API_URL,
    });
    setFetchAgain(true)
  }

  async function fetchPublicTransport() {
    const {
      data: {
        transport: { publicTransport: publicTransportValues },
      },
    } = await axios.get(`${API_URL}/admin/calculator/transport`);

    const mappedPublicTransport = Object.entries<PublicTransportBase>(
      publicTransportValues
    ).map(([transportType, values]) => {
      return {
        ...values,
        key: transportType,
        transportType:
          PUBLIC_TRANSPORT_TYPE_NAMES[transportType as PublicTransportType],
      };
    });

    setPublicTransport(mappedPublicTransport);
  }

  useEffect(() => {
    fetchPublicTransport();
  }, [fetchAgain]); // eslint-disable-line

  return (
    <>
      <CategoryHeader title="Transporte público" formName="publicTransport" />
      <form id="publicTransport" onSubmit={handleSubmit(onSubmit)}>
        <Table
          columns={columns}
          dataSource={publicTransport}
          pagination={false}
        />
      </form>
    </>
  );
}

export default PublicTransport;
